import PopupVideo from './popup-video.pug';

export default {
  props: {
    src: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      videoSrc: this.src,
    };
  },
  template: PopupVideo(),
  delimiters: ['${', '}}'],
  components: {},
  methods: {
    closePopup() {
      this.$emit('close-video-popup');
      window.bodyLock.clearAllBodyScrollLocks();
    },
  },
};



// WEBPACK FOOTER //
// ./blocks/popup/video/popup-video.js